import moment from "moment";
export default {
    Constantes: {
        lengthOTP: 5,
        porDefinir: 'por_definir',
        AvaluosMecanicos: 'avaluos mecanicos',
        emails:'Autorizo a la recopilación, tratamiento, transferencia y conservación de mis datos personales, con la finalidad de recibir información y notificaciones de cotizaciones, promociones y beneficios de parte de KIA ECUADOR y sus filiales.',
        tipoPaginas:[
            {
                label:'Compra tu KIA',
                url:'https://www.kia.com/ec/shopping-tools.html'
            },
            {
                label:'Postventa',
                url:'https://www.kia.com/ec/service.html'
            },
            {
                label:'Descubre KIA',
                url:'https://www.kia.com/ec/discover-kia.html'
            },
            {
                label:'Seminuevos',
                url:'https://www.kia.com/ec/seminuevos.html'
            }
        ],
        
        textos:{
            comboVacio:"No hay resultados",
            titulo:"Por favor completa la información solicitada en el siguiente formulario"
        },
        
        pasos: process.env.VUE_APP_ONLINE==='true' ?
            [
                {
                    numero: 1,
                    titulo: 'Elige tu vehículo',
                    icono: 'fa fa-hand-pointer',
                    pasos:[]
                },
                {
                    numero: 2,
                    titulo: 'Formulario',
                    icono: 'fa fa-car',
                    
                },
                {
                    numero: 3,
                    titulo: 'Simulador',
                    icono: 'flaticon-open-box',
                    pasos:[]
                },
                {
                    numero: 4,
                    titulo: 'Mantenimientos',
                    icono: 'la la-shopping-cart',
                    pasos:[]

                },
                {
                    numero: 5,
                    titulo: 'Compra en linea',
                    icono: 'fas fa-globe-americas',
                    pasos:[]

                }
            ]
            :
            [
                {
                    numero: 1,
                    titulo: 'Elige tu vehículo',
                    icono: 'fa fa-hand-pointer',
                    pasos:[]
                },
                {
                    numero: 2,
                    titulo: 'Personaliza',
                    icono: 'fa fa-car',
                    pasos:[
                        {
                            titulo: 'Especificaciones',
                            icono:"flaticon-interface-1"
                        },
                        {
                            titulo: 'Potencia',
                            icono:"flaticon-cogwheel-1"
                        },
                        {
                            titulo: 'Paquetes',
                            icono:"flaticon-tabs"
                        },
                        {
                            titulo: 'Accesorios',
                            icono:"la la-wrench"
                        },
                        {
                            titulo: 'Exterior',
                            icono:"fa fa-paint-brush"
                        }
                    ]
                },
                {
                    numero: 3,
                    titulo: 'Resumen',
                    icono: 'flaticon-open-box',
                    pasos:[]
                },
                {
                    numero: 4,
                    titulo: 'Cotiza tu Kia',
                    icono: 'la la-shopping-cart',
                    pasos:[]

                }
            ]
        ,
       
        mapaEstilos:[
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#a7a7a7"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#737373"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "hue": "#00ff41"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "weight": "1.86"
                    },
                    {
                        "gamma": "1.34"
                    },
                    {
                        "lightness": "-48"
                    },
                    {
                        "saturation": "-27"
                    },
                    {
                        "color": "#32424d"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#32424d"
                    }
                ]
            },
            {
                "featureType": "administrative.locality",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#32424d"
                    }
                ]
            },
            {
                "featureType": "administrative.neighborhood",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#32424d"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#32424d"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#efefef"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#696969"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#b3b3b3"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#d6d6d6"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "weight": 1.8
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#d7d7d7"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#808080"
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "hue": "#2800ff"
                    },
                    {
                        "visibility": "on"
                    },
                    {
                        "saturation": "-89"
                    }
                ]
            }
        ],
        
        formularioCompleto:"<h3 class=\"col\">Tu <b>KIA</b> ha sido personalizado, pronto recibirás la\n" +
            "cotización en tu correo electrónico <br />\n" +
            "<br/>\n" +
            "Gracias por preferir <b>KIA</b></h3>",
        validacion:{
            celular:{regex:/^[0]{1}[8-9]{1}[0-9]{8}$/},
            fijo:{regex:/^[0]{1}[2-8]{1}[0-9]{7}$/}
        },

        
    },
    funciones:{
        soloNumeros:function (evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        
        puntoMilesDecimal:function(numero){
            if(typeof numero === 'number')
                return numero.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            else
                return numero
        },
        buscarArrayPorId:function(array,id) {
            if(Array.isArray(array))
                for (let i = 0; i < array.length; i++) {
                    if (array[i].id === parseInt(id)) {
                        return array[i];
                    }
                }
            return {id:null};
        },
        sumar:function(paquetes) {
            return paquetes.reduce((suma, i) => suma + i.ndt1, 0);
        },
        sumar2:function(accesorios1,accesorios2) {
            const t1 = accesorios1.reduce((suma, i) => suma + i.ndt2, 0);
            const t2 = accesorios2.reduce((suma, i) => suma + i.ndt2, 0);
            return t1+t2;
        },
        sumar3:function(key,lista) {
            return lista.reduce((suma, i) => suma + parseFloat(i[key]), 0);
        },
        sumarSi:function(key,lista,key2,valor) {
            return lista.reduce((suma, i) => suma + (i[key2]!==valor ? parseFloat(i[key]) : 0 ), 0);
        },
        urlParse:function( cadena){
            return cadena.replace(/\s+/g, '-').toLowerCase();
        },
        isEmpty:function(obj) {
            for(var key in obj) {
                if(obj.hasOwnProperty(key))
                    return false;
            }
            return true;
        },
        formatoFechaH:function(fecha){
            return moment(fecha).fromNow();
        },
        formatoFechaD:function(fecha){
            return moment(fecha).format("LL");
        },
        formatoFechaInverso:function(fecha){
            if(fecha==="0001-01-01T00:00:00")
                return null;
            else
                return moment(fecha).format("DD/MM/YYYY");
        },
        formatoFechaL:function(fecha){
            return moment(fecha).format("LLLL");
        },
        minusculas:function(texto){
            let aux=String(texto);
            return aux.toLocaleLowerCase();
        },
        validarArray:function(array,minimo){
            return array.length >= minimo;
        },
        validarObje:function(obj){
            return !!obj.id
        },

        validarCi:function(value,opcion){
            let ruc = null
            if (typeof opcion !== 'object') {
                opcion = { id: 3 }
            } else if (!opcion.id) {
                opcion = { id: 3 }
            }
            if (value === '1212121212' || value === '2222222222') {
                return false
            }
            switch (opcion.id) {
                case 1:
                    ruc = value
                    if (typeof (ruc) === 'string' && ruc.length === 13 && /^\d+$/.test(ruc)) {
                        let digitos = ruc.split('').map(Number)
                        const codigoProvincia = digitos[0] * 10 + digitos[1]
                        let tipoModulo
                        let coeficientes
                        const digitoVer = digitos[2]
                        if (digitoVer !== 9 && (digitos[2] !== 9 && digitos[2] !== 6)) {
                            if ((codigoProvincia >= 1 && codigoProvincia <= 24) || codigoProvincia === 30) {
                                if (digitos[2] !== 7 || digitos[2] !== 8) {
                                    tipoModulo = (digitos[2] > 5) ? 11 : 10
                                    if (digitos[2] === 6) {
                                        digitos = digitos.slice(0, 9)
                                        coeficientes = [3, 2, 7, 6, 5, 4, 3, 2]
                                    } else {
                                        digitos = digitos.slice(0, 10)
                                        coeficientes = (digitos[2] === 9) ? [4, 3, 2, 7, 6, 5, 4, 3, 2] : [2, 1, 2, 1, 2, 1, 2, 1, 2]
                                    }
                                    const digitoVerificador = digitos.pop()
                                    let digitoCalculado = tipoModulo - digitos.reduce(function (valorPrevio, valorActual, indice) {
                                        let resultado = valorActual * coeficientes[indice]
                                        if (digitos[2] < 6) {
                                            resultado = (resultado > 9) ? resultado - 9 : resultado
                                        }
                                        return valorPrevio + resultado
                                    }, 0) % tipoModulo
                                    digitoCalculado = (digitoCalculado === 11 || digitoCalculado === 10) ? 0 : digitoCalculado
                                    if (digitoCalculado === digitoVerificador) {
                                        // eslint-disable-next-line no-unused-vars
                                        let sum = 0
                                        digitos.map(function (digito, indice) {
                                            let buff = 0
                                            buff = digito * coeficientes[indice]
                                            if (digitos[2] < 6 && buff > 9) {
                                                buff -= 9
                                            }
                                            // eslint-disable-next-line no-unused-vars
                                            sum += buff
                                        })
                                        return true
                                    }
                                }
                            }
                        }
                        return false
                    } else {
                        // ruc_resultado_validacion.innerHTML = 'No son 13 dígitos';
                        return false
                    }
                case 2:
                    ruc = value
                    if (typeof (ruc) === 'string' && ruc.length === 13 && /^\d+$/.test(ruc)) {
                        let digitos = ruc.split('').map(Number)
                        const codigoProvincia = digitos[0] * 10 + digitos[1]
                        let tipoModulo
                        let coeficientes
                        const digitoVer = digitos[2]
                        if (digitoVer !== 9 && (digitos[2] === 9 || digitos[2] === 6)) {
                            if ((codigoProvincia >= 1 && codigoProvincia <= 24) || codigoProvincia === 30) {
                                if (digitos[2] !== 7 || digitos[2] !== 8) {
                                    tipoModulo = (digitos[2] > 5) ? 11 : 10
                                    if (digitos[2] === 6) {
                                        digitos = digitos.slice(0, 9)
                                        coeficientes = [3, 2, 7, 6, 5, 4, 3, 2]
                                    } else {
                                        digitos = digitos.slice(0, 10)
                                        coeficientes = (digitos[2] === 9) ? [4, 3, 2, 7, 6, 5, 4, 3, 2] : [2, 1, 2, 1, 2, 1, 2, 1, 2]
                                    }
                                    const digitoVerificador = digitos.pop()
                                    let digitoCalculado = tipoModulo - digitos.reduce(function (valorPrevio, valorActual, indice) {
                                        let resultado = valorActual * coeficientes[indice]
                                        if (digitos[2] < 6) {
                                            resultado = (resultado > 9) ? resultado - 9 : resultado
                                        }
                                        return valorPrevio + resultado
                                    }, 0) % tipoModulo
                                    digitoCalculado = (digitoCalculado === 11) ? 0 : digitoCalculado
                                    if (digitoCalculado === digitoVerificador) {
                                        // eslint-disable-next-line no-unused-vars
                                        let sum = 0
                                        digitos.map(function (digito, indice) {
                                            let buff = 0
                                            buff = digito * coeficientes[indice]
                                            if (digitos[2] < 6 && buff > 9) {
                                                buff -= 9
                                            }
                                            // eslint-disable-next-line no-unused-vars
                                            sum += buff
                                        })
                                        return true
                                    }
                                }
                            }
                        }
                    }
                    return false
                case 3:
                    if (typeof (value) === 'string' && value.length === 10 && /^\d+$/.test(value)) {
                        const digitos = value.split('').map(Number)
                        const codigoProvincia = digitos[0] * 10 + digitos[1]
                        if (codigoProvincia >= 1 && (codigoProvincia <= 24 || codigoProvincia === 30)) {
                            const digitoVerificador = digitos.pop()
                            const digitoCalculado = digitos.reduce(
                                function (valorPrevio, valorActual, indice) {
                                    return valorPrevio - (valorActual * (2 - indice % 2)) % 9 - (valorActual === 9) * 9
                                }, 1000) % 10
                            return digitoCalculado === digitoVerificador
                        }
                    }
                    return false
                default:
                    return value.length >= opcion.ndt1
            }
        },

        

    }
};
